import { render, staticRenderFns } from "./SwotAnalysis.vue?vue&type=template&id=6ce55320&scoped=true"
import script from "./SwotAnalysis.vue?vue&type=script&lang=js"
export * from "./SwotAnalysis.vue?vue&type=script&lang=js"
import style0 from "./SwotAnalysis.vue?vue&type=style&index=0&id=6ce55320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce55320",
  null
  
)

export default component.exports